/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreasRequest
 */
export interface BulkImportFacilityServiceAreasRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkImportFacilityServiceAreasRequest
     */
    s3_key: string;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreasRequest interface.
 */
export function instanceOfBulkImportFacilityServiceAreasRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function BulkImportFacilityServiceAreasRequestFromJSON(json: any): BulkImportFacilityServiceAreasRequest {
    return BulkImportFacilityServiceAreasRequestFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreasRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        's3_key': json['s3_key'],
    };
}

export function BulkImportFacilityServiceAreasRequestToJSON(value?: BulkImportFacilityServiceAreasRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's3_key': value.s3_key,
    };
}

